import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Fragment, useEffect, useState } from 'react'
import { Toasts } from 'features/toast/toastSlice'
import Slide from 'components/animation/Slide'
import { isNullOrUndefined } from 'utils'
import Fade from 'components/animation/Fade'
import { ToastTypes } from 'features/Codes'
import Icon from 'components/Icon'
import NoneAnchor from 'components/NoneAnchor'
import store from '../../app/store'
import { errorMessages } from '../ErrorMessages'

const READABLE_DURATION = 3000
const SHORT_DURATION = 100
const LONG_DURATION = 2000

const Toast = ({
  id,
  color,
  type,
  duration = READABLE_DURATION,
  fadeIn = SHORT_DURATION,
  fadeOut = LONG_DURATION,
  children,
}) => {
  const dispatch = useDispatch()
  const [opaque, setOpaque] = useState(false)
  const [expanded, setExpanded] = useState(true)
  const [appliedFadeOut, setAppliedFadeOut] = useState(fadeOut)

  useEffect(() => {
    let timeout
    if (opaque) timeout = setTimeout(() => setOpaque(false), duration)
    return () => clearTimeout(timeout)
  }, [opaque, dispatch, duration])

  return (
    <Slide
      on={expanded}
      slideDown={fadeIn}
      slideUp={fadeIn}
      onExpand={() => setOpaque(true)}
      onCollapse={() => dispatch(Toasts.hide(id))}
      style={{ marginTop: 20 }}>
      <Fade
        className="tooltip_layer"
        on={opaque}
        fadeIn={fadeIn}
        fadeOut={appliedFadeOut}
        preserveElement={true}
        onFadeOut={() => {
          setExpanded(false)
        }}>
        <div
          className={`inner_tooltip_layer ${type.containerClass || ''}`}
          style={isNullOrUndefined(color) ? {} : { background: color }}>
          <strong className="tit_tooltip">
            <Icon name={type.iconName}>{type.iconText}</Icon>
          </strong>
          <div className="desc_tooltip">
            <p className="inner_desc">
              {children?.includes('\n')
                ? children.split('\n').map((line, index, array) => (
                    <Fragment key={`toast-line${index}`}>
                      {line}
                      {index < array.length - 1 && <br />}
                    </Fragment>
                  ))
                : children}
            </p>
          </div>
          <NoneAnchor
            className="btn_close"
            onClick={() => {
              setAppliedFadeOut(SHORT_DURATION)
              setOpaque(false)
            }}>
            <span className="ico_comm ico_close">닫기</span>
          </NoneAnchor>
        </div>
      </Fade>
    </Slide>
  )
}

export const success = message => store.dispatch(Toasts.success(message))
export const fail = message => store.dispatch(Toasts.fail(message))
export const failWithErrorResponse = (
  { errorCode, errorMessage: serverErrorMessage, fieldErrors = [] } = {
    errorCode: 500,
  },
  {
    defaultMessage = '알 수 없는 에러가 발생했습니다',
    messageMap: customMessageMap = {},
  } = {
    defaultMessage: '알 수 없는 에러가 발생했습니다',
    messageMap: {},
  }
) => {
  const messageMap = {
    ...errorMessages,
    ...customMessageMap,
  }
  const clientErrorMessage = messageMap[errorCode]
  const message =
    errorCode === 400 && fieldErrors?.length > 0
      ? '입력 불가능한 문자가 입력되어 있습니다.\n(일부 특수문자 및 한자 입력 불가능)'
      : clientErrorMessage === undefined &&
        errorCode >= 1000 &&
        serverErrorMessage
      ? serverErrorMessage
      : clientErrorMessage || defaultMessage
  fail(message)
}

Toast.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf([ToastTypes.SUCCESS, ToastTypes.FAIL]),
  color: PropTypes.string,
  duration: PropTypes.number,
  fadeIn: PropTypes.number,
  fadeOut: PropTypes.number,
  id: PropTypes.number.isRequired,
}

export default Toast
